const defaultSearchOptions = [
  {
    // 2
    key: 'skuSn',
    value: undefined,
    label: '单品编码',
    placeholder: '请输入单品编码',
    maxlength: 99,
    type: 'input',
  },
  {
    // 1
    key: 'skuName',
    value: undefined,
    label: '单品名称',
    placeholder: ' 请输入单品名称',
    maxlength: 99,
    type: 'input',
  },
  {
    // 0
    key: 'productCategoryId',
    value: '',
    label: '货品分类',
    placeholder: '请选择货品分类',
    type: 'cascader',
    options: [],
    props: {
      checkStrictly: true,
      value: 'id',
      label: 'label',
      children: 'children',
    },
  },
]

export { defaultSearchOptions }
